import { ClientConfigInit } from './src/client';

export type ClientConfigInit = ClientConfigInit;
export {
  AppId,
  appId,
  dontUpsell,
  dontDismissNotifications,
  limitMemoryUsage,
  desktopVersion,
} from './src/client';
export {
  slackDomain,
  slackTrelloDomain,
  trelloForWebsites,
  customFieldsId,
  firstPartyPluginsOrg,
  listLimitsPowerUpId,
  mapPowerUpId,
  bitbucketPowerUpId,
  attachmentsDomain,
  avatarDomain,
  backgroundDomain,
  logoDomain,
  oneDriveClientId,
  googleDriveClientId,
  dropboxClientAppKey,
  boxClientId,
  braintreeClientToken,
  googleMapsApiKey,
  snowplowCloudfrontServer,
  analyticsWebClientEnv,
  launchdarklyKey,
  appcuesAccountId,
  client,
  clientVersion,
  locale,
  aaManagedProfileUrl,
  aaManageRecentDevicesUrl,
  siteDomain,
} from './src/globals';
